<template>
  <el-drawer :title="newTitle" :visible.sync="dialogVisible" :before-close="handleClose">
    <div class="follow_list reminder_box">
      <el-timeline>
        <el-timeline-item
            placement="top"
            v-for="(item, index) in reminder_list"
            :key="index"
            :timestamp="item.create_time">
                  {{item.create_time}}  {{item.creator.nameZh}}({{item.creator.nameEn}})  催单成功
                  <div style="color:#409EFF;">催单内容： {{item.desc}}</div>
        </el-timeline-item>
      </el-timeline>
<!--      <div v-for="item in reminder_list">-->
<!--        {{item.create_time}}  {{item.creator.nameZh}}({{item.creator.nameEn}})  催单成功-->
<!--        <div> {{item.desc}}</div>-->
<!--      </div>-->
    </div>
  </el-drawer>
</template>
<script>
import { Editor } from "@/components/index.js";
import { formatEnToUtf8 } from "@/views/tops/devOps/components/util.js"

import {
  getDevOpsSpaceProducerListApi, getDevOpsSpaceReminderWorkOrderListlApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {getDevOpsSpaceAllUserListApi} from "@/server/tops/base";
export default {
  components: {Editor},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      form: {
        priority: 'P1',
        reviewer: {},
        re_details:'',
        demandDesc: '',
        reviewerId: '',
        progressRate: '',
        name:'',
        pmId: '',
      },

      rules: {
        name: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        projectId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        systemId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        demanderId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        pmId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        priority: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        expectFinishDate: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        demandDesc: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        reviewerId: {
          required: this.formInfo.id,
          message: "必填",
          trigger: "blur",
        },
        planFinishDate:{
          required: this.formInfo.id,
          message: "必填",
          trigger: "blur"
        },
        prdLink: {
          required: this.formInfo.id,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '135px',
      chainingLink: true,
      chainingLinkTo: true,
      loading: {
        dialog: false,
        submit: false,
      },
      reminder_list:[],
    };
  },
  async mounted() {
    const { id = '', status = '',  name = '', next = false } = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.form = { ...this.form, id, status, name}
    this.$set(this.form, 'username', username)
    this.username = username;
    if(this.$store.state.devOps.userInfo.userId){
      this.userId = this.$store.state.devOps.userInfo.userId;
    }

    //获取未开始，进行中的项目
    this.$nextTick(async () => {
      this.getReminderWorkOrderListlApi();
    })
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
        }
    ),
    newTitle(){
      return '催单详情 - 【'+this.formInfo.id+'】'+this.formInfo.title;
    },
  },
  methods: {
    async getReminderWorkOrderListlApi() {
      await getDevOpsSpaceReminderWorkOrderListlApi({workId: this.formInfo.id, type: '2'}).then((res) => {
        this.reminder_list = res.data;
      })
    },
    // 关闭弹窗
    handleClose() {
      this.hideDialogVisible()
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      let h = today.getHours() < 10 ? '0'+today.getHours() : today.getHours();
      let m = today.getMinutes() < 10 ? '0'+today.getMinutes() : today.getMinutes();
      let s = today.getSeconds() < 10 ? '0'+today.getSeconds() : today.getSeconds();
      return year + "-" + cmonth + "-" + cday + " " + h + ":" + m + ":" + s;
    },
    getDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
  }
};
</script>
<style lang="scss">
.demand_model_dialog {
  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
}
.follow_list {
  max-height: 85vh;
  overflow-y: auto;
  white-space: pre-wrap;
  /* background: #f1fbec; */
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
  line-height: 24px;
  padding: 10px;
}
.el-drawer__header {
  font-size: 14px;
}

.reminder_box .el-timeline-item__wrapper {
  position: relative;
  padding-left: 28px;
  top: -15px;
  font-size: 13px;
}

.reminder_box .el-timeline-item__timestamp.is-top {
  margin-bottom: 0px;
  padding-top: 0;
  margin-top: 0;
}
</style>
